import React from 'react';

export const Leading = ({
  pageName,
  title,
  subtitle,
  img,
}: {
  pageName: string;
  title: string;
  subtitle: string;
  img?: string;
}) => {
  return (
    <div
      className="relative"
      style={{ background: 'linear-gradient(90deg, #7329ce, #4610db)' }}
    >
      {img && (
        <img
          src={img}
          alt={`${pageName}_banner`}
          className="absolute h-full w-full object-cover items-center hidden sm:block"
        />
      )}
      <div className="h-full flex flex-col p-4 sm:p-16 px-4 gap-1 w-full sm:w-3/5  sm:gap-4 justify-center">
        <span className="z-[3] text-xl sm:text-2xl font-semibold text-accent">
          {pageName}
        </span>
        <div className="z-[3] leading-[1.25em] text-3xl sm:text-4xl lg:text-5xl text-background dark:text-foreground">
          {title}
        </div>
        <p className="z-[3] text-sm sm:text-base text-background dark:text-foreground">
          {subtitle}
        </p>
      </div>
    </div>
  );
};
